// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class AutocompleteMatchedSubstring {
  readonly length: number;
  readonly offset: number;

  constructor(data: { [key: string]: any } = {}) {
    this.length = data.length === undefined ? 0 : data.length;
    this.offset = data.offset === undefined ? 0 : data.offset;
  }

  static zero(): AutocompleteMatchedSubstring {
    const zeroValues: ExcludeMethodsDeep<AutocompleteMatchedSubstring> = {
      length: 0,
      offset: 0,
    };
    return new AutocompleteMatchedSubstring(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type AutocompleteMatchedSubstringWireFormat = {
  length: number;
  offset: number;
};

type NewAutocompleteMatchedSubstringProps = PartialDeep<
  AutocompleteMatchedSubstring,
  { recurseIntoArrays: true }
>;
export const NewAutocompleteMatchedSubstring: (
  props: NewAutocompleteMatchedSubstringProps,
) => AutocompleteMatchedSubstring = (props) => new AutocompleteMatchedSubstring(props);

type NewAutocompleteMatchedSubstringFromWireFormatProps = PartialDeep<
  AutocompleteMatchedSubstringWireFormat,
  { recurseIntoArrays: true }
>;
export const NewAutocompleteMatchedSubstringFromWireFormat: (
  props: NewAutocompleteMatchedSubstringFromWireFormatProps,
) => AutocompleteMatchedSubstring = (props) => new AutocompleteMatchedSubstring(props);
